<template>
    <section class="interview-title pink">
        <div class="css-grid">
            <div class="bg" style="background-image: url(/static/img/pages/interview-kathy-ilse.jpg)"></div>

            <div class="content-wrapper">
                <div class="content pink">
                    <h3>Interview Kathy&nbsp;Rogmans en Ilse&nbsp;de&nbsp;Leeuw</h3>
                    <h2>Ondanks coronatijd veel aandacht voor onderwijskwaliteit</h2>
                    <button class="white" @click="openInterview">Lees het interview</button>
                </div>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
</style>

<script>
    import InterviewKathyIlse from '@/app/pages/sub/InterviewKathyIlse';

    export default {
        name: 'OnderwijskwaliteitInterview',
        meta: {
            title: 'OnderwijskwaliteitInterview',
            color: '#fe1362'
        },

        components: {
        },

        methods: {
            openInterview()
            {
                this.$emit( 'openOverlay', InterviewKathyIlse );
            }
        }
    };
</script>
